import { Section } from '../../components/Section/Section';
import { HighLightedText } from '../../components/HighLightedText/HighLightedText';
import React from 'react';
import { MuiMarkdown } from '../../components/MuiMarkdown';
import { Alert, AlertTitle, Box, Container } from '@mui/material';
import { useWindowDimensions } from '../../hooks';
import { InformationPage } from '../../components/Page/InformationPage';

export default function CookiesPage() {
  return (
    <InformationPage
      title="Wij zijn transparant in welke
Cookies we plaatsen."
      selectedTab={4}
      seo={{
        description:
          'AppCenter Nederland gebruikt functionele, analytische en tracking cookies. Een cookie is een klein tekstbestand dat bij het eerste bezoek aan deze website wordt opgeslagen in de browser van uw computer, tablet of smartphone.',
        openGraph: {
          type: 'website',
          locale: 'nl_NL',
          title:
            'Wij zijn transparant in welke Cookies we plaatsen. | AppCenter Nederland',
          description:
            'AppCenter Nederland gebruikt functionele, analytische en tracking cookies. Een cookie is een klein tekstbestand dat bij het eerste bezoek aan deze website wordt opgeslagen in de browser van uw computer, tablet of smartphone.',
          images: [
            {
              url: 'https://appcenternederland-general.ams3.cdn.digitaloceanspaces.com/appcenternederland-website/featured_img_home_v2.jpg',
              secureUrl:
                'https://appcenternederland-general.ams3.cdn.digitaloceanspaces.com/appcenternederland-website/featured_img_home_v2.jpg',
              width: 1920,
              height: 1080,
              alt: 'AppCenter Nederland gebruikt functionele, analytische en tracking cookies. Een cookie is een klein tekstbestand dat bij het eerste bezoek aan deze website wordt opgeslagen in de browser van uw computer, tablet of smartphone.',
              type: 'image/jpeg',
            },
          ],
          site_name: 'AppCenter Nederland',
        },
      }}
    >
      <Section1 />
    </InformationPage>
  );
}

function Section1() {
  const { isMobile } = useWindowDimensions();
  return (
    <Section
      position={'center'}
      caption={'Kristalhelder over welke cookies we plaatsen.'}
      title={
        <>
          Wij zijn transparant in welke {!isMobile && <br />}
          <HighLightedText
            TypographyProps={{ color: 'secondary' }}
            text={'Cookies'}
          />{' '}
          we plaatsen.
        </>
      }
    >
      <Box mt={4} />
      <Markdown />
      <Box mt={4} />
      <Container maxWidth={'md'}>
        <Alert
          severity="info"
          sx={{
            backgroundImage:
              'linear-gradient(rgba(255, 255, 255, 0.05), rgba(255, 255, 255, 0.05))',
            backgroundColor: '#05123b',
          }}
        >
          <AlertTitle>Transparantie</AlertTitle>
          Dit Cookie statement is voor het laatst geüpdatet op{' '}
          <strong>23-08-2022</strong>
        </Alert>
      </Container>
    </Section>
  );
}

// prettier-ignore
function Markdown() {

  return <MuiMarkdown>
    {`
AppCenter Nederland gebruikt functionele, analytische en tracking cookies. Een cookie is een klein tekstbestand dat bij het eerste bezoek aan deze website wordt opgeslagen in de browser van uw computer, tablet of smartphone. AppCenter Nederland gebruikt cookies met een puur technische functionaliteit. Deze zorgen ervoor dat de website naar behoren werkt en dat bijvoorbeeld uw voorkeursinstellingen onthouden worden. Deze cookies worden ook gebruikt om de website goed te laten werken en deze te kunnen optimaliseren. Daarnaast plaatsen we cookies die uw surfgedrag bijhouden zodat we op maat gemaakte content en advertenties kunnen aanbieden. Bij uw eerste bezoek aan onze website hebben wij u al geïnformeerd over deze cookies en toestemming gevraagd voor het plaatsen ervan. U kunt zich afmelden voor cookies door uw internetbrowser zo in te stellen dat deze geen cookies meer opslaat. Daarnaast kunt u ook alle informatie die eerder is opgeslagen via de instellingen van uw browser verwijderen.

[Zie deze website voor een toelichting.](https://veiliginternetten.nl/themes/situatie/cookies-wat-zijn-het-en-wat-doe-ik-ermee/)

Op deze website worden ook cookies geplaatst door derden. Dit zijn bijvoorbeeld adverteerders en/of de sociale media-bedrijven. Waaronder:

**Cookie:**  Google Analytics
**Naam:**  _utma
**Functie:**  Analytische cookie die websitebezoek meet.
**Bewaartermijn:**  Google slaat gegevens op zolang zij deze nodig hebben om producten en diensten aan te bieden.

**Cookie:**  Google Tag Manager
**Naam:**  _gtm
**Functie:** Analytische cookie die websitebezoek en andere aanvragen meet.
**Bewaartermijn:**  Google slaat gegevens op zolang zij deze nodig hebben om producten en diensten aan te bieden.

**Cookie:**  Facebook
**Naam:**  _fbp
**Functie:** Analytische cookie die websitebezoek en andere aanvragen meet.
**Bewaartermijn:**  Facebook slaat gegevens op zolang zij deze nodig hebben om producten en diensten aan te bieden.

**Cookie:**  LinkedIn
**Naam:**  _li_referer
**Functie:**  Analytische cookie die websitebezoek en andere aanvragen meet.
**Bewaartermijn:**  LinkedIn slaat gegevens op zolang zij deze nodig hebben om producten en diensten aan te bieden.
`}
  </MuiMarkdown>
}
